import React from 'react';
import { PureComponent } from 'react';

export default class TableauNavigation extends PureComponent {
  constructor(props) {
    super(props);
    this.iframeRef = React.createRef();
    this.messageHandler = this.onMessage.bind(this);
  }

  componentDidMount() {
    window.addEventListener('message', this.messageHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.messageHandler);
  }

  onMessage(event) {
    if (event.origin !== window.location.origin)
      return;

    if (!event.data || event.data.type !== 'tableau-navigate')
      return;

    const url = event.data.url;
    if (typeof url !== 'string' || url.trim().length === 0)
      return;

    if (this.props.onNavigate)
      this.props.onNavigate(url);
  }

  render() {
    return (
      <iframe
        ref={this.iframeRef}
        className="pwx-tableau-navigation-frame"
        src={this.props.navigationUrl}
        title="Tableau Dashboard Navigation"
      />
    );
  }
}
